export default __webpack_public_path__ + "static/media/reward-tiers3.633b0d34.webp";